module.exports = "/src/views/games/other/images/maps/map_4.png";